import { render, staticRenderFns } from "./CrearPreguntaSalle.vue?vue&type=template&id=61c6c72e&scoped=true"
import script from "./CrearPreguntaSalle.vue?vue&type=script&lang=js"
export * from "./CrearPreguntaSalle.vue?vue&type=script&lang=js"
import style0 from "./CrearPreguntaSalle.vue?vue&type=style&index=0&id=61c6c72e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c6c72e",
  null
  
)

export default component.exports